export class SessionStorageService {
  static setItem(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  static getItem(key: string): any {
    const value = window.sessionStorage.getItem(key);

    return value !== null ? JSON.parse(value) : null;
  }

  static removeItem(key: string): void {
    window.sessionStorage.removeItem(key);
  }

  static clear(): void {
    window.sessionStorage.clear();
  }
}
